import './index.scss';
import classnames from 'classnames';
import { func, object } from 'prop-types';
import React, { useState } from 'react';
import AccordionCollapse from './accordion_collapse';
import AccordionToggle from './accordion_toggle';
import SingleItem from './single_item';
const ClauseItem = (props) => {
    ClauseItem.propTypes = {
        activeClause: object,
        clause: object.isRequired,
        setActiveClause: func,
    };
    const { activeClause, clause, setActiveClause, } = props;
    const [isToggled, setIsToggled] = useState(false);
    const isSingleItem = clause.clauses.length === 1;
    const onClickClauseSection = () => {
        if (!isSingleItem) {
            setIsToggled(!isToggled);
        }
        if ((activeClause === null || activeClause === void 0 ? void 0 : activeClause.clauseName) !== clause.displayName) {
            setActiveClause(clause.clauses[0]);
        }
    };
    const clauseClassName = classnames('clause-item', { active: clause.displayName === (activeClause === null || activeClause === void 0 ? void 0 : activeClause.clauseName) });
    const accordionClass = classnames('clause-accordion-section', {
        selected: isToggled,
        single: isSingleItem,
    });
    return (React.createElement("div", { className: accordionClass, onClick: !isToggled ? onClickClauseSection : undefined },
        !isSingleItem &&
            React.createElement(React.Fragment, null,
                React.createElement(AccordionToggle, { clause: clause, classificationName: clause.displayName, isToggled: isToggled, onClickClauseSection: onClickClauseSection }),
                React.createElement(AccordionCollapse, { activeClause: activeClause, classificationName: clause.displayName, clauses: clause.clauses, setActiveClause: setActiveClause })),
        isSingleItem &&
            React.createElement(SingleItem, { clauseClassName: clauseClassName, clause: clause, onClickClauseSection: onClickClauseSection })));
};
export default ClauseItem;
